import {
  SET_PROJECT_CREATION_DRAFT,
  CLEAR_PROJECT_CREATION_DRAFT,
  CLEAR_ALL,
} from '../actions/constants';

const initialState = {
  messages: [],       // conversation history [{role, content, timestamp}]
  collectedData: {},  // fields collected so far
  savedAt: null,      // epoch ms of last save
};

export default function projectCreationDraftReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PROJECT_CREATION_DRAFT:
      return {
        messages: action.payload.messages,
        collectedData: action.payload.collectedData,
        savedAt: Date.now(),
      };
    case CLEAR_PROJECT_CREATION_DRAFT:
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}
